// The browser tab says where you are in the portal ("Campaigns — Earn"),
// and a form with unsaved changes asks before the tab closes or reloads.

import {useEffect} from 'react';

export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} — Earn` : 'Brand portal — Earn';
  }, [title]);
}

export function useLeaveWarning(unsaved: boolean): void {
  useEffect(() => {
    if (!unsaved) return undefined;
    const warn = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [unsaved]);
}
